import PropTypes from 'prop-types';
import qs from 'query-string';
import React from 'react';
import root from 'window-or-global';
import epicTracking from 'epic-tracking';

export default class SocialShareBanner extends React.Component {
  static propTypes = {
    shareConfigs: PropTypes.array,
    disableShareIcons: PropTypes.bool,
    meta: PropTypes.array,
    hide: PropTypes.bool,
    // locale: PropTypes.string
  };

  static defaultProps = {
    shareConfigs: [],
    hide: false,
  };

  state = {
    shareFacebook: this.share.bind(this, 'facebook'),
    shareTwitter: this.share.bind(this, 'twitter'),
    shareReddit: this.share.bind(this, 'reddit'),
    showQRCode: false,
  };

  /**
   * Generate the correct social share window when click share icons
   * @param  {String} social Type of social share, options include ['twitter', 'facebook', 'reddit']
   */
  share(social) {
    const {meta} = this.props;
    let twitterTitle;
    let twitterDesc;
    let twitterTags;
    const {origin, pathname, search} = root.location;
    const {v} = qs.parse(search);
    let shareUrl = v ? `${origin}${pathname}?v=${v}` : `${origin}${pathname}`; // append ?v={version} if it's available
    let desc = '';
    for (let x = 0; x < meta.length; x++) {
      const {name} = meta[x];
      if (name === 'twitter:title') {
        twitterTitle = meta[x].content;
      } else if (name === 'twitter:description') {
        twitterDesc = meta[x].content;
      } else if (name === 'twitter:hashTags') {
        twitterTags = meta[x].content;
      }
    }
    if (twitterTags) {
      desc += ` ${twitterTags} `;
    }
    if (twitterTitle.length > 0) {
      desc += `${twitterTitle} `;
    }
    if (twitterDesc.length > 0) {
      desc += twitterDesc;
    }
    switch (social) {
      case 'twitter':
        shareUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(
          desc
        )}&url=${encodeURIComponent(shareUrl)}`;
        break;
      case 'facebook':
        shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`;
        break;
      case 'reddit':
        shareUrl = `https://reddit.com/submit?url=${encodeURIComponent(shareUrl)}`;
        break;
      default:
        break;
    }

    if (root._epicTracking) {
      epicTracking.trackEvent('Interaction', {
        eventCategory: `share - ${social}`,
        eventAction: 'cta',
        eventLabel: 'share_Creative_island',
        eventValue: 'TRUE',
        interactionType: 'click',
      });
    }

    root.open(shareUrl, '_blank', 'toolbar=no, resizeable=yes, width=600, height=450');
  }

  /**
   * onClick to toggleQRCode
   */
  toggleQRCode() {
    const showQRCode = !this.state.showQRCode;
    this.setState({showQRCode});
  }

  render() {
    const {shareFacebook, shareTwitter, shareReddit} = this.state;
    const {shareConfigs, hide} = this.props;

    /*
     * CMS - Epic Common Config/ Common Config Content Type
     * Enable share that has been specifed in CMS
     * */
    let shareButtons = [];
    if (!this.props.disableShareIcons) {
      shareButtons = shareConfigs.map((type) => {
        let temp = null;
        switch (type) {
          case 'twitter':
            temp = (
              <button className="social-share-button" onClick={shareTwitter} key={type}>
                <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                  <path d="M512 97.2534C492.833 105.761 472.494 111.335 451.667 113.789C473.612 100.67 490.031 80.0108 497.855 55.6702C477.237 67.9129 454.677 76.5389 431.151 81.1751C421.326 70.6886 409.45 62.3327 396.261 56.6259C383.072 50.9191 368.851 47.9832 354.481 48.0001C296.476 48.0001 249.447 95.0293 249.447 153.044C249.447 161.265 250.372 169.278 252.17 176.98C164.867 172.594 87.4587 130.782 35.6487 67.2275C26.3041 83.259 21.3967 101.49 21.4308 120.046C21.4308 156.484 39.9722 188.641 68.1586 207.473C51.4776 206.944 35.1646 202.436 20.5785 194.326L20.5681 195.656C20.5681 246.541 56.778 288.987 104.836 298.653C89.3618 302.842 73.1369 303.453 57.3912 300.44C70.7673 342.169 109.555 372.548 155.513 373.39C118.308 402.597 72.3578 418.437 25.058 418.362C16.5875 418.362 8.22102 417.863 0 416.886C48.0276 447.755 103.929 464.14 161.022 464.081C354.242 464.081 459.888 304.026 459.888 165.215C459.888 160.662 459.795 156.12 459.597 151.61C480.166 136.76 497.913 118.352 512 97.2534Z" />
                </svg>
              </button>
            );
            break;
          case 'facebook':
            temp = (
              <button className="social-share-button" onClick={shareFacebook} key={type}>
                <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                  <path d="M512 256C512 114.615 397.385 0 256 0C114.615 0 0 114.615 0 256C0 383.777 93.616 489.685 216 508.89V330H151V256H216V199.6C216 135.44 254.219 100 312.695 100C340.704 100 370 105 370 105V168H337.719C305.918 168 296 187.733 296 207.978V256H367L355.65 330H296V508.89C418.385 489.685 512 383.777 512 256Z" />
                </svg>
              </button>
            );
            break;
          case 'reddit':
            temp = (
              <button className="social-share-button" onClick={shareReddit} key={type}>
                <svg viewBox="0 0 1000 1000" xmlns="http://www.w3.org/2000/svg">
                  <path d="M671.769 609.785C628.696 609.785 593.576 574.666 593.576 531.592C593.576 488.519 628.696 453.399 671.769 453.399C714.843 453.399 749.963 488.519 749.963 531.592C749.963 574.666 714.843 609.785 671.769 609.785ZM685.577 738.106C632.148 791.385 529.942 795.588 499.925 795.588C469.908 795.588 367.552 791.385 314.273 738.106C306.318 730.152 306.318 717.395 314.273 709.44C322.227 701.486 334.984 701.486 342.939 709.44C376.557 743.059 448.447 755.065 499.925 755.065C551.253 755.065 623.293 743.059 656.911 709.44C664.866 701.486 677.623 701.486 685.577 709.44C693.381 717.395 693.381 730.152 685.577 738.106ZM249.587 531.592C249.587 488.519 284.707 453.399 327.78 453.399C370.854 453.399 405.973 488.519 405.973 531.592C405.973 574.666 370.854 609.785 327.78 609.785C284.707 609.785 249.587 574.666 249.587 531.592ZM1000 453.399C1000 392.916 951.073 343.989 890.59 343.989C861.024 343.989 834.309 355.696 814.648 374.756C739.907 320.726 636.8 285.907 521.987 281.855L571.815 47.276L734.654 81.9451C736.605 123.368 770.524 156.386 812.397 156.386C855.621 156.386 890.59 121.417 890.59 78.193C890.59 34.9692 855.621 0 812.397 0C781.63 0 755.365 17.8598 742.608 43.674L560.708 4.95273C555.606 3.90215 550.353 4.80265 546 7.65422C541.648 10.5058 538.646 14.8582 537.596 19.961L482.966 277.353C482.665 278.853 482.966 280.204 482.966 281.705C366.051 284.707 260.994 319.676 185.052 374.456C165.391 355.546 138.826 343.989 109.41 343.989C48.9269 343.989 0 393.066 0 453.399C0 497.824 26.5646 536.095 64.6856 553.204C63.0347 564.01 62.1342 575.116 62.1342 586.373C62.1342 754.765 258.142 891.19 499.925 891.19C741.708 891.19 937.716 754.765 937.716 586.373C937.716 575.266 936.815 564.31 935.164 553.504C973.135 536.395 1000 498.124 1000 453.399" />
                </svg>
              </button>
            );
            break;

          default:
            break;
        }
        return temp;
      });
    }

    if (hide) return <div></div>;
    return <div className="social-share-banner">{shareButtons}</div>;
  }
}
